import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Input } from '../../../form';

export type ContactFieldsType = {
  name: string;
  email: string;
  phone?: string;
};

export type ContactFieldsProps = {
  controlId: string;
};

export const ContactFields: React.FC<React.PropsWithChildren<ContactFieldsProps>> = ({ controlId }) => {
  return (
    <Row className="contact-fields">
      <Col xs={12} lg={4}>
        <Input
          type="text"
          label="Contact Person"
          controlId={`${controlId}.name`}
          required={true}
          additionalAttributes={{ maxLength: 255 }}
        />
      </Col>
      <Col xs={12} lg={4}>
        <Input type="text" label="Email" controlId={`${controlId}.email`} required={true} additionalAttributes={{ maxLength: 255 }} />
      </Col>
      <Col xs={12} lg={4}>
        <Input
          type="tel"
          label="Phone number"
          placeholder="optional"
          controlId={`${controlId}.phone`}
          additionalAttributes={{ maxLength: 255 }}
        />
      </Col>
    </Row>
  );
};
